module.exports = __webpack_public_path__ + "media/images/pc/brands/eight/store_eight-be7dd5b62b198d3fb00982bb6b0bb469.jpg";